/**
 * Created by jiachenpan on 16/11/18.
 */
import {checkPartnerModeType} from "../views/enterpriseNetwork";
import Big from "big.js";
import dayjs from "dayjs";
import {getNum} from "./upload";

export function parseTime (time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  let date;
  if (typeof time === 'object') {
    date = time
  } else {
    if (('' + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  return format.replace(/{([ymdhisa])+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
}

export function formatTime (time, option) {
  time = +time * 1000;
  const d = new Date(time);
  const now = Date.now();

  const diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) { // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分'
  }
}
export function merge (target) {
  for (let i = 1, j = arguments.length; i < j; i++) {
    let source = arguments[i] || {};
    for (let prop in source) {
      if (source.hasOwnProperty(prop)) {
        let value = source[prop];
        if (value !== undefined) {
          target[prop] = value;
        }
      }
    }
  }
  return target;
}
export function GetRequest () {
  let url = location.search; //获取url中"?"符后的字串
  let theRequest = {};
  if (url.indexOf("?") !== -1) {
    let str = url.substr(1);
    let strs = str.split("&");
    for (let i = 0; i < strs.length; i++) {
      theRequest[strs[i].split("=")[0]] = unescape(strs[i].split("=")[1]);
    }
  }
  return theRequest;
}
export function guid () {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    let r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}
export function runScript (script) {
  // 直接 document.head.appendChild(script) 是不会生效的，需要重新创建一个
  let newScript = document.createElement('script');
  // 获取 inline script

  newScript.innerHTML = script.innerHTML;
  // 存在 src 属性的话
  let src = script.getAttribute('src');

  if (src) {
    newScript.setAttribute('src', src);
  }

  document.head.appendChild(newScript);
  document.head.removeChild(newScript);
}
export function setHTMLWithScript (container, rawHTML) {
  container.innerHTML = rawHTML;
  let scripts = container.querySelectorAll('script');

  for (let script of scripts) {
    this.runScript(script);
  }
}

// 数字转千位符带小数点
export function toThousands (num) {
  // let result = '', counter = 0;
  // num = (num || 0).toString();
  // for (let i = num.length - 1; i >= 0; i--) {
  //   counter++;
  //   result = num.charAt(i) + result;
  //   if (!(counter % 3) && i !== 0) {
  //     result = ',' + result;
  //   }
  // }
  // return result;
  return new Intl.NumberFormat('en-US', {
    maximumFractionDigits: 2, // 设置最大小数位数
    minimumFractionDigits: 0  // 设置最小小数位数
  }).format(getNum(num) || 0);
}

// 校验两个值是否相同
/**
 * @param firstValue
 * @param secondValue
 */
export const checkTwoValueIsEquals = (firstValue, secondValue) => {
  // 检查数字比较
  if (typeof firstValue === 'number' && typeof secondValue === 'number') {
    return Big(firstValue).eq(Big(secondValue));
  }

  // 检查字符串比较
  if (typeof firstValue === 'string' && typeof secondValue === 'string') {
    return firstValue === secondValue;
  }

  // 检查 null 或非对象类型
  if (firstValue === secondValue) return true;
  if (firstValue == null || typeof firstValue !== 'object' || secondValue == null || typeof secondValue !== 'object') {
    return false;
  }

  // 检查数组比较
  if (Array.isArray(firstValue) && Array.isArray(secondValue)) {
    if (firstValue.length !== secondValue.length) return false;
    for (let i = 0; i < firstValue.length; i++) {
      if (!checkTwoValueIsEquals(firstValue[i], secondValue[i])) return false;
    }
    return true;
  }

  // 检查对象比较
  const keys1 = Object.keys(firstValue);
  const keys2 = Object.keys(secondValue);
  if (keys1.length !== keys2.length) return false;

  for (const key of keys1) {
    if (!keys2.includes(key) || !checkTwoValueIsEquals(firstValue[key], secondValue[key])) {
      return false;
    }
  }

  return true;
}


export const formatDate = (value) => {
  if (!value) return '-'
  return dayjs(value).format('YYYY-MM-DD')
}



// WEBPACK FOOTER //
// ./src/utils/index.js